import { useQuery } from '@tanstack/react-query';
import { USER_CACHE_KEY } from '@/consts/const';
import { useFetch } from '@/hooks/useFetch';
import type { GetUserResponse } from '@/types/apiTypes';

export const useGetUserData = () => {
  const { doFetch } = useFetch<unknown, GetUserResponse>();

  return useQuery({
    queryKey: [USER_CACHE_KEY],
    queryFn: () => doFetch('/api/user/'),
  });
};
